export const TksEditFields = () => {
  return {
    '006': {
      name: 'МЕТР',
      short: 'М',
      sign: 0,
    },
    '055': {
      name: 'КВАДРАТНЫЙ МЕТР',
      short: 'М2',
      sign: 0,
    },
    '111': {
      name: 'КУБИЧЕСКИЙ САНТИМЕТР',
      short: 'СМ3',
      sign: 0,
    },
    '112': {
      name: 'ЛИТР',
      short: 'Л',
      sign: 0,
    },
    '113': {
      name: 'КУБИЧЕСКИЙ МЕТР',
      short: 'М3',
      sign: 0,
    },
    '114': {
      name: '1000 КУБИЧЕСКИХ МЕТРОВ',
      short: '1000 М3',
      sign: 0,
    },
    '117': {
      name: 'Тонна полной массы',
      short: 'ТПМ',
      sign: 5,
    },
    '118': {
      name: 'Метр кубический внутреннего объема кузова',
      short: 'М3ВОК',
      sign: 0,
    },
    '130': {
      name: '1000 ЛИТРОВ',
      short: '1000 Л',
      sign: 0,
    },
    '162': {
      name: 'МЕТРИЧЕСКИЙ КАРАТ(1КАРАТ=2*10(-4)КГ',
      short: 'КАР',
      sign: 0,
    },
    '163': {
      name: 'ГРАММ',
      short: 'Г',
      sign: 5,
    },
    '166': {
      name: 'КИЛОГРАММ',
      short: 'КГ',
      sign: 3,
    },
    '168': {
      name: 'ТОННА, МЕТРИЧЕСКАЯ ТОННА (1000 КГ)',
      short: 'Т',
      sign: 5,
    },
    '185': {
      name: 'ГРУЗОПОДЪЕМНОСТЬ В ТОННАХ',
      short: 'Т ГРП',
      sign: 5,
    },
    '214': {
      name: 'КИЛОВАТТ',
      short: 'КВТ',
      sign: 0,
    },
    '246': {
      name: '1000 КИЛОВАТТ-ЧАС',
      short: '1000 КВТ*Ч',
      sign: 0,
    },
    '251': {
      name: 'ЛОШАДИНАЯ СИЛА',
      short: 'Л.С.',
      sign: 0,
    },
    '305': {
      name: 'КЮРИ',
      short: 'КИ',
      sign: 0,
    },
    '306': {
      name: 'ГРАММ ДЕЛЯЩИХСЯ ИЗОТОПОВ',
      short: 'Г Д/И',
      sign: 1,
    },
    '508': {
      name: '1000 МЕТРОВ КУБИЧЕСКИХ В ЧАС',
      short: 'ТЫС М3/Ч',
      sign: 0,
    },
    '715': {
      name: 'ПАРА',
      short: 'ПАР',
      sign: 0,
    },
    '796': {
      name: 'ШТУКА',
      short: 'ШТ',
      sign: 0,
    },
    '797': {
      name: 'СТО ШТУК',
      short: '100 ШТ',
      sign: 0,
    },
    '798': {
      name: 'ТЫСЯЧА ШТУК',
      short: '1000 ШТ',
      sign: 0,
    },
    '831': {
      name: 'ЛИТР ЧИСТОГО (100%) СПИРТА',
      short: 'Л 100% СПИРТА',
      sign: 0,
    },
    '841': {
      name: 'КИЛОГРАММ ПЕРОКСИДА ВОДОРОДА',
      short: 'КГ H2O2',
      sign: 3,
    },
    '845': {
      name: 'КИЛОГРАММ 90 %-ГО СУХОГО ВЕЩЕСТВА',
      short: 'КГ 90% С/В',
      sign: 3,
    },
    '852': {
      name: 'КИЛОГРАММ ОКСИДА КАЛИЯ',
      short: 'КГ K2O',
      sign: 3,
    },
    '859': {
      name: 'КИЛОГРАММ ГИДРОКСИДА КАЛИЯ',
      short: 'КГ KOH',
      sign: 3,
    },
    '861': {
      name: 'КИЛОГРАММ АЗОТА',
      short: 'КГ N',
      sign: 3,
    },
    '863': {
      name: 'КИЛОГРАММ ГИДРОКСИДА НАТРИЯ',
      short: 'КГ NAOH',
      sign: 0,
    },
    '865': {
      name: 'КИЛОГРАММ ПЯТИОКИСИ ФОСФОРА',
      short: 'КГ P2O5',
      sign: 3,
    },
    '867': {
      name: 'КИЛОГРАММ УРАНА',
      short: 'КГ U',
      sign: 3,
    },
  } as const;
};
